import { useState, useEffect } from 'react'
import { getScrollProgress } from '@utils/index'

/**
 * Hook to track scroll progress
 */
export function useScrollProgress() {
    const [progress, setProgress] = useState(0)

    useEffect(() => {
        const updateProgress = () => {
            setProgress(getScrollProgress())
        }

        // Update on scroll
        window.addEventListener('scroll', updateProgress, { passive: true })

        // Update on resize
        window.addEventListener('resize', updateProgress)

        // Initial update
        updateProgress()

        return () => {
            window.removeEventListener('scroll', updateProgress)
            window.removeEventListener('resize', updateProgress)
        }
    }, [])

    return progress
}